import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/Button";

export const SubscriptionPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f5f5f9] flex items-center justify-center p-4">
      <div className="bg-white p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <svg
            className="w-16 h-16 mx-auto text-primary-blue"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Subscription</h1>
        <p className="text-lg text-gray-700 mb-8">Coming soon.</p>
        <Button
          onClick={() => navigate("/")}
          className="w-full bg-primary-blue text-white hover:bg-indigo-darker-blue"
        >
          Back to Home
        </Button>
      </div>
    </div>
  );
};
